import React from 'react';
import styled from 'styled-components';

import VideoPresentacion from '../VideoPresentacion';
import imgDiv22 from '../../images/todo/precios.jpg';

const DivBodyInicio2 = () => {
    return(
        <DivBodyInicio2CSS>
                <h1 className="tituloDiv2">Tú Solo Tienes que Escoger tamaño y Ubicación de tu Parcela</h1>
                <h1 className="tituloDiv2">NOSOTROS TE LO FINANCIAMOS!</h1>
                <VideoPlayer>
                    <div className="videoInicio1"><VideoPresentacion></VideoPresentacion></div>
                    <div className="videoInicio2">
                        <h2>Son 179 Parcelas de 4100 mts cuadrados a 5900 mts cuadrados</h2>
                        <h1>Por solo 10.000 pesos el mtr Cuadrado </h1>
                        <ImgDiv2>
                            <img src={imgDiv22} alt="" />
                        </ImgDiv2>
                    </div>
                </VideoPlayer>
            </DivBodyInicio2CSS>
    )
}
export default DivBodyInicio2;

const DivBodyInicio2CSS = styled.div`
  width: 100%;
  height:40%;
  margin-bottom: 0%;
  background-color: #003333;
  @media(max-width: 1024px) {
    height: 50%;
    
  }
  @media(max-width: 768px) {
    height: 90%;
   
  }
  @media(max-width: 480px) {
    height: 65%;
    
  }
  @media(max-width: 320px) {
    height: 60%;
    
  }
    h1 {
      font-family: widen latin;
      color: #efb810;
      font-size: 40px;
      margin: 0%;
      @media(max-width:768px) {
          font-size: 27px;
      }
      @media(max-width:480px) {
          font-size: 20px;
      }
      @media(max-width:320px) {
          font-size: 20px;
      }
    }
`;

const VideoPlayer = styled.div`
    width: 100%;
    height: 70%;
    display: flex;
    @media(max-width: 768px) {
        display: block;
    }
    @media(max-width: 480px) {
        display: block;
    }
    @media(max-width: 320px) {
        display: block;
    }
    .videoInicio1 {
        width: 50%;
        height: 90%;
        margin: 2%;
        box-shadow: 2px 4px 4px 2px ;
        @media(max-width: 768px) {
        width: 100%;
        height: 43%;
        margin-top:3%;
        }
        @media(max-width: 480px) {
        width: 100%;
        height: 45%;
        margin-top:3%;
        }
        @media(max-width: 320px) {
        width: 100%;
        height: 45%;
        margin-top:3%;
        }
    }
    .videoInicio2 {
        width: 50%;
        height: 90%;
        margin: 0%;
        @media(max-width: 768px) {
        width: 100%;
        height: 55%;
        margin-top:20%;
        }
        @media(max-width: 480px) {
        width: 100%;
        height: 55%;
        margin-top:20%;
        }
        @media(max-width: 320px) {
        width: 100%;
        height: 55%;
        margin-top:20%;
        }
    }
    .videoInicio2 h2 {
        font-family: widen latin;
        color: green; 
        margin: 0%;
        padding:1%;
        @media(max-width: 320px) {
            font-size: 18px;  
        }       
    }
    .videoInicio2 h1 {
        font-family: widen latin;
        color: #fff;
        font-size: 30px;
        margin: 0%;
        text-decoration:underline;
        padding:1%;
        @media(max-width: 320px) {
            font-size: 20px;
            padding:1%;
        }
        @media(max-width: 480px) {
            font-size: 23px;
            padding:1%;
        }
    }
`;

const ImgDiv2 = styled.div`
    width:100%;
    height:65%;
    margin-top:3%;
    @media(max-width: 1200px) {
           height: 60%;
    }
    @media(max-width: 480px) {
           height: 60%;
    }
    @media(max-width: 320px) {
           height: 58%;
    }
    
    img{
        width: 100%;
        height: 100%;
    }
`;